import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, DefaultValueAccessor } from '@angular/forms';
//import { Router, ActivatedRoute, Params } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { IInterestCriteriaInputModel, ILookUpList } from '../../shared/models/InterestCriteriaInputModel';
import { IStatesList } from '../../shared/models/StatesListOutputModel';
import { CommonService } from '../../shared/providers/common.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { ToastService } from '../../shared/providers/toast.service';
import { UserManagerService } from '../../shared/providers/user-manager.service';
import { ValidationService } from '../../shared/providers/validation.service';
import { ReplaySubject, Observable } from 'rxjs';
import { TagInputModule } from 'ngx-chips';
import { IUser } from '../../shared/models/user';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionService } from '../../shared/providers/permission.service';
import { Actions, Modules } from '../../shared/enum/enum';

enum LookUpsType {
  AssetTypes = 2,
  Strategies = 20,
  Geography = 21
}
interface IDropDownData {
  value: number;
  display: string;
  TypeId: number;
}
enum ActionList {
  Save = 1,
  Update = 2
}

@Component({
  selector: 'app-add-interest-criteria',
  templateUrl: './add-interest-criteria.component.html',
  styleUrls: ['./add-interest-criteria.component.css']
})
export class AddInterestCriteriaComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private permissionService: PermissionService, private _commonService: CommonService, public authService: AuthenticationService, private modalService: BsModalService,
    private _userManagerService: UserManagerService, public _validationService: ValidationService, private Toast: ToastService,
    private router: Router, private Loader: LoaderService, private cdRef: ChangeDetectorRef) {

  }

  modalRef: BsModalRef;
  interestCriteriaForm: FormGroup;
  interestcriteriaInputModel = {} as IInterestCriteriaInputModel;
  statesList = [];
  assetType: ILookUpList[];
  DuplicateAsset: string[];
  leaseTerm: ILookUpList[];
  Duplicateleaseterm: string[];
  tenants: any[];
  states: any[];
  geography: ILookUpList[];
  Duplicategeography: string[];
  subCategoriesList = [];
  tenantlst: IDropDownData[];
  statelst: IDropDownData[];
  tenantids: number[] = [];
  stateids: number[] = [];
  propertytypeIds: number[] = [];
  action = ActionList.Save;
  DataEmpty: string = "-";
  loggedUserDetails: any;
  @Input() IsInitialLoad: number = 0;
  user: any;
  @Input() UserId: number = 0;
  IsPropertyTypeAdded: boolean = false;
  IsGeographyAdded: boolean = false;
  IsLeaseAdded: boolean = false;
  canEdit = false;
  defaultTypeSettings = {
    singleSelection: false,
    text: "Select",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  };
  //defaultTypeText: IMultiSelectTexts = {
  //  checked: 'item selected',
  //  checkedPlural: 'items selected',
  //  defaultTitle: 'Select'
  //};
  ngOnInit(): void {
    this.user = this.authService.user;
    if (this.authService.Principal() || this.authService.Principal1031()) {
      this.canEdit = true;
    }
    else {
      this.canEdit = this.permissionService.hasPermission(Modules.BuyerCriteria, Actions.Edit);
    }
    this._commonService.getTypeList().subscribe(response => {
      this.assetType = response.map(o => {
        return { id: o.Id, description: o.Type, selected: false };
      });
    });

    this._commonService.getLookupsByTypeId(LookUpsType.Geography).subscribe(response => {
      this.geography = response.map(o => { return { id: o.Id, description: o.Description, selected: false }; });
    });
    this._commonService.getLookupsByTypeId(12).subscribe(response => {
      this.leaseTerm = response.map(o => { return { id: o.Id, description: o.Description, selected: false }; });
    });
    this.authService.isLoggedIn.subscribe(response => {
      if (response) {
        this.loggedUserDetails = this.authService.user;

      }
    });
    this.LoadContents();
  }

  LoadContents() {
    this.Loader.display(true);

    this._commonService.getStateList().subscribe(response => {
      this.statelst = response.map(o => {
        return {
          value: o.Id, display: o.StateName, TypeId: 0
        };
      });
    });
    this.gettenantdetails();
    this._userManagerService.GetInterestCriteriaDetails(this.UserId).subscribe(res => {
      if (res != null && res["UserId"] != null && res["UserId"] != 0) {
        this.interestcriteriaInputModel.capratemax = res["CapRateMax"];
        this.interestcriteriaInputModel.capratemin = res["CapRateMin"];
        this.interestcriteriaInputModel.releasetermmax = res["Releasetermmax"];
        this.interestcriteriaInputModel.releasetermmin = res["Releasetermmin"];
        this.interestcriteriaInputModel.askingpricemax = res["Askingpricemax"];
        this.interestcriteriaInputModel.askingpricemin = res["Askingpricemin"];
        this.interestcriteriaInputModel.SelectedSubcategoryList = res["SelectedSubcategoryList"];
        this.selectedPropertyType = res["PropertyTypes"];
        this.selectedGeography = res["GeographyTypes"];
        this.selectedLease = res["LeaseTerms"];
        this.interestcriteriaInputModel.PropertyTypeSubcategoryList = res["PropertyTypeSubcategoryList"];
        //this.interestcriteriaInputModel.interestedStateList = res["InterestedStateList"];
        this.tenantids = res["TenantList"];
        this.stateids = res["InterestedStateList"];
        this.tenants = res["SelectedTenantList"].map(o => {
          return {
            value: o.Id, display: o.TenantName, TypeId: 0
          };
        });

        if (res["SelectedStates"] != null) {
          this.states = res["SelectedStates"].map(o => {
            return {
              value: o.Id, display: o.TenantName, TypeId: 0
            };
          });
        }

        if (this.IsInitialLoad == 1) {
          this.DuplicateAsset = this.selectedPropertyType != null ? this.selectedPropertyType.split(',') : [];
          this.Duplicategeography = this.selectedGeography != null ? this.selectedGeography.split(',') : [];
          this.Duplicateleaseterm = this.selectedLease != null ? this.selectedLease.split(',') : [];

        }
        if (this.IsInitialLoad != 1) {
          let Propcount = 0;
          let PropertyType = [];
          if (res["PropertyType"] != null) {
            PropertyType = res["PropertyType"];
          }
          if (this.assetType) {
            PropertyType.forEach(item => {
              let found = this.assetType.find(x => x.id === item.Id);
              if (found) {
                Propcount++;
                found.selected = true;
                this.propertytypeIds.push(item.Id)
              }
            });
          }

          if (PropertyType != null && this.propertytypeIds.length > 0) {
            this.bindSubCategories();
          }
          if (Propcount == (this.assetType ? this.assetType.length : 0)) {
            if (PropertyType != null && PropertyType.length > 0) {
              this.selectAllAssetTypeValue = true;
            }
            else {
              this.selectAllAssetTypeValue = false;
            }
          }
          else {
            this.selectAllAssetTypeValue = false;
          }

          let Geographycount = 0;
          let GeographyType = [];
          if (res["GeographyType"] != null) {
            GeographyType = res["GeographyType"];
          }
          if (this.geography) {
            GeographyType.forEach(item => {
              let found = this.geography.find(x => x.id === item.Id);
              if (found) {
                Geographycount++;
                found.selected = true;
              }
            });
          }

          if (Geographycount == (this.geography ? this.geography.length : 0)) {
            if (GeographyType != null && GeographyType.length > 0) {
              this.selectAllgeographyValue = true;
            }
            else {
              this.selectAllgeographyValue = false;
            }
          }
          else {
            this.selectAllgeographyValue = false;
          }
          let LeaseTermCount = 0;
          let LeastTerms = [];
          if (res["LeaseTerm"] != null) {
            LeastTerms = res["LeaseTerm"];
          }
          if (this.leaseTerm) {
            LeastTerms.forEach(item => {
              let found = this.leaseTerm.find(x => x.id === item.Id);
              if (found) {
                LeaseTermCount++;
                found.selected = true;
              }
            });
          }
        }

      }
      this.interestCriteriaForm = new FormGroup({
        'txtcapMin': new FormControl(this.interestcriteriaInputModel.capratemin, [
        ]),
        'txtcapMax': new FormControl(this.interestcriteriaInputModel.capratemax, [
        ]),
        'txtRentMin': new FormControl(this.interestcriteriaInputModel.askingpricemin, [
        ]),
        'txtRentMax': new FormControl(this.interestcriteriaInputModel.askingpricemax, [
        ]),
        'releasetermmin': new FormControl(this.interestcriteriaInputModel.releasetermmin, [
        ]),
        'releasetermmax': new FormControl(this.interestcriteriaInputModel.releasetermmax, [
        ]),
        'lstSubcatgeories': new FormControl(this.interestcriteriaInputModel.PropertyTypeSubcategoryList),
      })

      this.Loader.display(false);
    });

  }
  selectAllAssetTypeValue = false;
  selectedPropertyType = '';
  assetsChecked(id: number, event: any) {
    this.propertytypeIds = [];
    let count = 0;
    this.selectedPropertyType = '';
    this.assetType.forEach(item => {
      if (item.selected == true) {
        count++;
        this.selectedPropertyType += item.description + ", ";
        this.propertytypeIds.push(item.id)
      }

    });

    if (count == this.assetType.length) {
      this.selectAllAssetTypeValue = true;
    }
    else {
      this.selectAllAssetTypeValue = false;
    }
    this.selectedPropertyType = this.selectedPropertyType.slice(0, -2);
    this.bindSubCategories(event);


  }

  assetsCheckAll(event: any) {
    this.propertytypeIds = [];
    this.selectedPropertyType = '';
    if (event.target.checked) {
      this.assetType.forEach(item => {
        item.selected = true;
        this.selectedPropertyType += item.description + ", ";
        this.propertytypeIds.push(item.id)

      });
    }
    else {
      this.assetType.forEach(item => {
        item.selected = false;
      });
    }
    this.selectedPropertyType = this.selectedPropertyType.slice(0, -2);
    this.bindSubCategories(event);
    this.changeCurrentSelection1();
    this.cdRef.detectChanges();
  }
  selectAllgeographyValue = false;
  selectedGeography = '';

  geographyChecked(id: number, event: any) {
    let count = 0;
    this.selectedGeography = '';
    this.geography.forEach(item => {
      if (item.selected == true) {
        count++;
        this.selectedGeography += item.description + ", ";
      }
    });
    if (count == this.geography.length) {
      this.selectAllgeographyValue = true;
    }
    else {
      this.selectAllgeographyValue = false;
    }
    this.selectedGeography = this.selectedGeography.slice(0, -2);
  }
  geographyCheckAll(event: any) {
    this.selectedGeography = '';
    if (event.target.checked) {
      this.geography.forEach(item => {
        item.selected = true;
        this.selectedGeography += item.description + ", ";
      });
    }
    else {
      this.geography.forEach(item => {
        item.selected = false;
      });
    }
    this.selectedGeography = this.selectedGeography.slice(0, -2);
  }

  selectedLease = '';

  LeaseStructureChecked(id: number, event: any) {
    let count = 0;
    this.selectedLease = '';
    this.leaseTerm.forEach(item => {
      if (item.selected == true) {
        count++;
        this.selectedLease += item.description + ", ";
      }
    });

    this.selectedLease = this.selectedLease.slice(0, -2);
  }

  bindSubCategories(event = null) {
    let i = 0;
    if (this.propertytypeIds != undefined && this.propertytypeIds.length > 0) {

      this._commonService.getSubcategoryList(this.propertytypeIds).subscribe(res => {
        this.subCategoriesList = res.map(o => {
          return { id: o["Id"], name: o["Name"] };

        });

        if (event != null) {
          this.changeCurrentSelection();
        }
        i = 1;
      });
    }
    else {

      this.subCategoriesList = [];
      this.interestcriteriaInputModel.PropertyTypeSubcategoryList = [];
      this.cdRef.detectChanges();
      i = 1;

    }
    //if (i == 1) {
    //  this.interestcriteriaInputModel.PropertyTypeSubcategoryList.forEach(item => {
    //    if (this.subCategoriesList.length > 0) {
    //      if (this.subCategoriesList.findIndex(x => x.id != item)) {
    //        var index = this.interestcriteriaInputModel.PropertyTypeSubcategoryList.indexOf(item);
    //        if (index > -1) {
    //          this.interestcriteriaInputModel.PropertyTypeSubcategoryList.splice(index, 1);
    //        }
    //      }
    //    }
    //    else {
    //      this.interestcriteriaInputModel.PropertyTypeSubcategoryList = [];
    //    }
    //  });

    //  this.changeCurrentSelection1();
    //  this.cdRef.detectChanges();
    //}
  }

  changeCurrentSelection() {
    let Subcategory: number[] = [];
    if (this.subCategoriesList != null && this.subCategoriesList.length > 0) {
      this.subCategoriesList.forEach(item => {
        if (this.interestcriteriaInputModel.PropertyTypeSubcategoryList.indexOf(item.id) > -1) {
          Subcategory.push(item.id);
        }
      });
    }
    this.interestCriteriaForm.get("lstSubcatgeories").patchValue(Subcategory);
    this.interestcriteriaInputModel.PropertyTypeSubcategoryList = Subcategory;
    this.cdRef.detectChanges();
    this.interestcriteriaInputModel.PropertyTypeSubcategoryList.forEach(item => {
      if (this.subCategoriesList.length > 0 && item != null) {
        if (this.subCategoriesList.findIndex(x => x.id != item)) {
          var index = this.interestcriteriaInputModel.PropertyTypeSubcategoryList.indexOf(item);
          if (index > -1) {
            this.interestcriteriaInputModel.PropertyTypeSubcategoryList.splice(index, 1);
          }
        }
      }
      else {
        this.interestcriteriaInputModel.PropertyTypeSubcategoryList = [];
      }
    });

    this.changeCurrentSelection1();
    this.cdRef.detectChanges();
  }
  changeCurrentSelection1() {
    let Subcategory: number[] = [];
    if (this.subCategoriesList != null && this.subCategoriesList.length > 0) {
      this.subCategoriesList.forEach(item => {
        if (this.interestcriteriaInputModel.PropertyTypeSubcategoryList.indexOf(item.id) > -1) {
          Subcategory.push(item.id);
        }
      });
    }
    this.interestCriteriaForm.get("lstSubcatgeories").patchValue(Subcategory);
    this.interestcriteriaInputModel.PropertyTypeSubcategoryList = Subcategory;


  }

  tenantSearch(event) {
    if (event && event != '') {
      this._commonService.GetInterestedTeanantBySearch(event).subscribe(response => {
        this.tenantlst = response.map(o => {
          return {
            value: o.Id, display: o.TenantName, TypeId: 0
          };
        });
      });
    }
  }
  stateSearch(event) {
    if (event && event != '') {
      this._commonService.GetInterestedStatesBySearch(event).subscribe(response => {
        this.tenantlst = response.map(o => {
          return {
            value: o.Id, display: o.TenantName, TypeId: 0
          };
        });
      });
    }
  }
  gettenantdetails() {
    this._commonService.GetTenantList().subscribe(response => {
      this.tenantlst = response.map(o => {
        return {
          value: o.Id, display: o.TenantName, TypeId: 0
        };
      });
    });
  }
  onAdd(event, filtername) {
    if (filtername == "Tenant") {
      this.tenantids.push(event.value);
    }
    else {
      this.stateids.push(event.value);
    }
  }

  onRemove(event, filterName) {
    if (filterName == "Tenant") {
      const index = this.tenantids.indexOf(event.value);
      if (index > -1) {
        this.tenantids.splice(index, 1);
      }
    }
    else {
      const index = this.stateids.indexOf(event.value);
      if (index > -1) {
        this.stateids.splice(index, 1);
      }
    }

  }

  onsubmit() {
    if (!this.interestCriteriaForm.invalid) {
      if (!this.interestCriteriaForm.invalid) {
        if (this.IsTradePreferenceValid()) {
          this.Loader.display(true);
          this.interestcriteriaInputModel.propertytype = this.assetType;
          this.interestcriteriaInputModel.geographytype = this.geography;
          this.interestcriteriaInputModel.leaseTerm = this.leaseTerm;
          this.interestcriteriaInputModel.loggedinUserId = this.user.Id;
          this.interestcriteriaInputModel.userid = this.UserId;
          this.interestcriteriaInputModel.tenantList = this.tenantids;
          this.interestcriteriaInputModel.interestedStateList = this.stateids;
          this._userManagerService.SaveInterestCriteria(this.interestcriteriaInputModel).subscribe(res => {
            if (res) {
              this.resetModel();
              this.IsInitialLoad = 1;
              this.LoadContents();
              this.Toast.addToast({ title: 'Success', msg: 'Acquisition Criteria has been saved successfully.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
              this.Loader.display(false);
            }
          });
        }
      }
    }
    else {
      this.Toast.addToast({ title: 'Error Occurred', msg: 'Please fill all the required field', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      this.Loader.display(false);
    }
  }
  editCriteria() {
    this.IsInitialLoad = 2;
    this.resetModel();
    this.LoadContents();
  }
  resetModel() {
    this.interestcriteriaInputModel = {
      capratemax: null,
      capratemin: null,
      releasetermmax: null,
      releasetermmin: null,
      askingpricemax: null,
      askingpricemin: null,
      propertytype: [],
      propertytypes: null,
      leaseTerm: [],
      leaseTerms: null,
      geographytype: [],
      geographytypes: null,
      PropertyTypeSubcategoryList: [],
      tenantList: [],
      interestedStateList: [],
      loggedinUserId: this.user.Id,
      userid: this.UserId,
    };
    this.propertytypeIds = [];
    this.tenants = [];
    this.states = [];
    this.DuplicateAsset = [];
    this.Duplicategeography = [];
    this.Duplicateleaseterm = [];
  }

  clearFeilds() {
    this.resetModel();
    this.IsInitialLoad = 1;
    this.LoadContents();
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode == 46) {
      return true;
    }
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  IsTradePreferenceValid() {
    this.validateDecimals();
    if (Number(this._validationService.IsNullThen(this.interestcriteriaInputModel.capratemin, 0)) > 100) {
      this.Toast.addToast({ title: 'Error Occurred', msg: 'Minimum Cap Rate should not be greater than 100', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
    else if (Number(this._validationService.IsNullThen(this.interestcriteriaInputModel.capratemax, 0)) > 100) {
      this.Toast.addToast({ title: 'Error Occurred', msg: 'Maximum Cap Rate should not be greater than 100', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
    else if ((Number(this._validationService.IsNullThen(this.interestcriteriaInputModel.capratemax, 0)) > 0) && (Number(this._validationService.IsNullThen(this.interestcriteriaInputModel.capratemin, 0)) > Number(this._validationService.IsNullThen(this.interestcriteriaInputModel.capratemax, 0)))) {

      this.Toast.addToast({ title: 'Error Occurred', msg: 'Minimum Cap Rate should not be greater than Maximum Cap Rate', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
    else if ((Number(this._validationService.IsNullThen(this.interestcriteriaInputModel.askingpricemax, 0)) > 0) && (Number(this._validationService.IsNullThen(this.interestcriteriaInputModel.askingpricemin, 0)) > Number(this._validationService.IsNullThen(this.interestcriteriaInputModel.askingpricemax, 0)))) {
      this.Toast.addToast({ title: 'Error Occurred', msg: 'Minimum Asking Price  should not be greater than Maximum Asking Price', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
    else {
      return true;
    }
    return false;
  }

  validateDecimals() {
    this.interestcriteriaInputModel.capratemin = this._validationService.DecimalOnly(this.interestcriteriaInputModel.capratemin);
    this.interestcriteriaInputModel.capratemax = this._validationService.DecimalOnly(this.interestcriteriaInputModel.capratemax);
    this.interestcriteriaInputModel.askingpricemin = this._validationService.DecimalOnly(this.interestcriteriaInputModel.askingpricemin);
    this.interestcriteriaInputModel.askingpricemax = this._validationService.DecimalOnly(this.interestcriteriaInputModel.askingpricemax);
  }

  onlyDecimal(event) {
    if (event.target.value == ".") {
      event.target.value = "";
    }
  }
}
